import { MusicBoxMultipleIcon } from './MusicBoxMultipleIcon';

/**
 * author: Google
 * id 56F24AF4-9E5B-4E53-89ED-3472E08C9466
 * name music-box-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-box-multiple.svg
 * tags
 * - Music 
 */
export const LibraryMusicIcon = MusicBoxMultipleIcon;
export default LibraryMusicIcon